/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Layout from "../../components/Layout/layout";
import SciCommitteeCard from "../../components/SciCommitteeCard/SciCommitteeCard";

const members = [
  {
    name: "Prof. Pijush Samui",
    desig: "Professor",
    url: "https://nitp.irins.org/profile/100911",
  },
  {
    name: "Dr. Rahul Bhartiya",
    desig: "Assistant Professor",
    url: "https://iitism.irins.org/profile/324534",
  },
  {
    name: "Dr. Vishwajit Anand",
    desig: "Assistant Professor",
    url: "https://iitbhu.ac.in/dept/civ/people/anandciv",
  },
  {
    name: "Dr. Shiva Shankar Choudhary",
    desig: "Assistant Professor (Dept. of Civil Engg.)",
    url: "https://nitp.irins.org/profile/103940",
  },
  {
    name: "Dr. Sukanta Das",
    desig: "Faculty (Adhoc)",
    url: "https://sites.google.com/view/mrsukantadas/home",
  },
  {
    name: "Dr. Sangeeta",
    desig: "Postdoctoral Researcher",
    url: "https://www.researchgate.net/profile/Sangeeta-Sangeeta-13",
  },
  {
    name: "Dr. Smrutirekha Sahoo",
    desig: "Assistant Professor Grade I",
    url: "https://nitm.ac.in/department/civil-engineering/faculty-6/dr-smrutirekha-sahoo-1",
  },
  {
    name: "Dr. Rubi Chakraborty",
    desig: "Assistant Professor",
    url: "https://nitm.ac.in/department/civil-engineering/faculty-6/dr-rubi-chakraborty",
  },
  {
    name: "Dr. Babloo Chaudhary",
    desig: "Assistant Professor",
    url: "https://civil.nitk.ac.in/professor/babloo-chaudhary",
  },
  {
    name: "Dr. Arvind Kumar Jha",
    desig: "Assistant Professor",
    url: "https://www.iitp.ac.in/index.php/people-10/cee-faculty/2-uncategorised/359-view-profile-103",
  },
  {
    name: "Dr. NARAYAN ROY",
    desig: "Assistant Professor",
    url: "https://jaduniv.irins.org/profile/124338",
  },
  {
    name: "Dr. Sreevalsa Kolathayar",
    desig: "Assistant Professor",
    url: "https://civil.nitk.ac.in/professor/sreevalsa-kolathayar",
  },
  {
    name: "Dr. Bharathi M.",
    desig: "Assistant Professor",
    url: "https://www.researchgate.net/profile/Bharathi-M-2",
  },
  {
    name: "Dr. Rana Acharyya",
    desig: "Assistant Professor",
    url: "https://www.researchgate.net/profile/Rana-Acharyya",
  },
  {
    name: "Dr. Swapnil Mishra",
    desig: "Assistant Professor",
    url: "https://iitism.irins.org/profile/215130",
  },
  {
    name: "Dr. Resmi Sebastian",
    desig: "Assistant Professor, Department of Civil Engineering",
    url: "https://iitrpr.irins.org/profile/88969",
  },
  {
    name: "Dr. Pradeep Kumar Dammala",
    desig: "Assistant Professor",
    url: "https://pradeepkumardammal.wixsite.com/iitj",
  },
  {
    name: "Dr. Shantanu Patra",
    desig: "Associate Professor",
    url: "https://iitbbs.irins.org/profile/102814",
  },
  {
    name: "Dr. Aditya Parihar",
    desig: "Assistant Professor",
    url: "https://www.thapar.edu/faculties/view/Dr.-Aditya-Parihar/MTg4/Mw==",
  },
  {
    name: "Dr. Madhumita Mohanty",
    desig: "Adhoc Faculty",
    url: "https://nitandhra.ac.in/dept/civil/22915",
  },
  {
    name: "Dr. Olympa Baro",
    desig: "Assistant Professor",
    url: "http://ce.nits.ac.in/olympa/",
  },
  {
    name: "Dr. Kunjari Mog",
    desig: "Assistant Professor",
    url: "https://portfolios.nith.ac.in/index.php?/nith/dr-kunjari-mog",
  },
  {
    name: "Dr. Anindya Pain",
    desig: "Principal Scientist",
    url: "https://cbri.res.in/scientific-profiles/group-iv/principal-scientist/anindya-pain/",
  },
  {
    name: "Dr. Pavan Kumar Emani",
    desig: "Professor",
    url: "https://sit.irins.org/profile/167299",
  },
  {
    name: "Dr. Aniket Rajkumar Tidke",
    desig: "Post-Doctoral Fellow",
    url: "https://www.researchgate.net/profile/Aniket-Tidke",
  },
  {
    name: "Dr. Dhiraj Raj",
    desig: "Assistant Professor",
    url: "https://mnit.ac.in/dept_civil/profile?fid=RqiM",
  },
  {
    name: "Dr. Arindam Dey",
    desig: "Associate Professor",
    url: "https://www.iitg.ac.in/arindam.dey/homepage/index.html",
  },
  {
    name: "Dr. Abhijit Anand",
    desig: "Assistant Professor",
    url: "https://www.researchgate.net/profile/Abhijit-Anand",
  },
  {
    name: "Dr. G Kalyan Kumar",
    desig: "Associate Professor",
    url: "https://nitw.irins.org/profile/153881",
  },
  {
    name: "Dr. Naveen James",
    desig: "Assistant Professor",
    url: "https://www.iitrpr.ac.in/node/2061",
  },
  {
    name: "Dr. Supriya Mohanty",
    desig: "Assistant Professor",
    url: "https://iitbhu.ac.in/dept/civ/people/supriyaciv",
  },
];

const stripPrefix = (name) => {
  return name.replace(/^(Prof\.|Dr\.|Mr\.|Mrs\.|Ms\.\s)/i, "").trim();
};

const sortedMembers = members.sort((a, b) =>
  stripPrefix(a.name).localeCompare(stripPrefix(b.name))
);

const SciCommittee = () => {
  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 border-2 bg-white z-20 mb-[5vh] relative mx-auto">
          <div className="mb-[2rem]">
            <span className="font-bold text-4xl text-[#1F7E95] mb-10">
              Scientific Committee
            </span>
          </div>
          <div className="flex flex-wrap justify-between">
            {sortedMembers.map((member, index) => {
              return (
                <div key={index}>
                  <SciCommitteeCard
                    name={member.name}
                    desig={member.desig}
                    url={member.url}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SciCommittee;
